/**
 * AP-10 — FM-WIN-18: ISOBUS-Detailfenster.
 *
 * Titel `"<Name> (PGN 0x<pgn>)"` (IsobusDetailWindow.cpp:35), ein Fenster je
 * PGN — genau wie `isobusDetailWindows_` im Original nach `decoded.pgn`
 * geschluesselt ist (CanMonitorApp.cpp:2663-2671).
 */

import { createDetailWindow, type DetailWindowHandle } from './detailWindow';

export function createIsobusDetailWindow(pgn: number, name: string): DetailWindowHandle {
  const title = `${name === '' ? 'ISOBUS' : name} (PGN 0x${pgn.toString(16).toUpperCase().padStart(6, '0')})`;
  return createDetailWindow(title);
}
